import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import Vuelidate from "vuelidate";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import Sortable from "vue-sortable";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { dom } from "@fortawesome/fontawesome-svg-core";
import vueSignature from "vue-signature";
import VueCodemirror from "vue-codemirror";
import VueScrollTo from "vue-scrollto";
import axios from "axios";
import VueAxios from "vue-axios";
import vSelect from "vue-select";
import ToggleButton from "vue-js-toggle-button";
import VueRouter from "vue-router";
//import "core-js/stable";
//import "regenerator-runtime/runtime";
//importing router file
import router from "./router";
import CountryFlag from "vue-country-flag";
import wysiwyg from "vue-wysiwyg";
import VueTour from "vue-tour";

// client - pri side menu
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

import VueNumber from "vue-number-animation";

// initilizgin store
import store from "./store";
// require styles
import "codemirror/lib/codemirror.css";
import "vue-select/dist/vue-select.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";

import "vue-tour/dist/vue-tour.css";

import VueCurrencyInput from "vue-currency-input";
import i18n from "./i18n";

// hihgt charts .js
import HighchartsVue from "highcharts-vue";

import VueTimeago from "vue-timeago";

import { getAccessToken } from "./utils/auth-requests";
import { interceptEBORequest } from "./helpers/interceptor";
import { EventBus } from "./event-bus";
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
library.add(fas);

if (process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds") {
    //Set axios interceptors
    axios.interceptors.request.use(
        async function(config) {
            let url = config.url;
            [url, config] = await interceptEBORequest(url, config);
            return config;
        },
        function(error) {
            // Do something with request error
            return Promise.reject(error);
        }
    );
    // The API answers with sessionExpired when this device's session was ended server side,
    // e.g. the password was changed or reset on another device. SessionTimeout logs the user out
    axios.interceptors.response.use(function(response) {
        if (response && response.data && response.data.sessionExpired === true) {
            EventBus.$emit("sessionExpired");
        }
        return response;
    });
}

// make sure we can use it in our components
Vue.use(VueRouter);
Vue.use(VueTour);
Vue.use(wysiwyg, {});
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.component("country-flag", CountryFlag);
Vue.component("vue-cropper", VueCropper);
Vue.component('multiselect', Multiselect)
Vue.use(ToggleButton);
Vue.use(VueScrollTo);
Vue.use(VueCurrencyInput);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Sortable);
Vue.use(Vuelidate);
Vue.use(vueSignature);
Vue.use(VueNumber);
Vue.use(VueSidebarMenu);
Vue.use(HighchartsVue);
Vue.use(VueGoodTablePlugin);

Vue.use(VueTimeago, {
    name: "Timeago", // Component name, `Timeago` by default
    locale: "en", // Default locale
    // We use `date-fns` under the hood
    // So you can use all locales from it
    locales: {},
});

//you can set default global options and events when use
Vue.use(VueCodemirror, {});

if (process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds") {
    //Registers interceptors for fetch api
    /* fetchIntercept.register({
    request: async function(url, config) {
      [url, config] = await interceptEBORequest(url, config);
      return [url, config];
    },

    requestError: function(error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },

    response: function(response) {
      // Modify the reponse object
      return response;
    },

    responseError: function(error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });
*/
    //Gets a access token if the refresh token is still valid
    getAccessToken(store).then(() => {
        const vm = new Vue({
            router,
            store,
            i18n,
            render: (h) => h(App),
        }).$mount("#app");
    });
} else {
    const vm = new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount("#app");
}